<template>
  <md-table-cell
    :id="item.sequence"
    class="font-16 line-height-20 fix-margin-padding"
    :class="isItemSelected(item)"
  >
    <div :class="isUnderInvestigation(item)">
      <div
        class="md-layout md-gutter md-size-100 font-size-16 text-align-start cell-formatting"
      >
        <div class="md-layout-item md-size-40">
          <span>{{ $t("common.Account") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span class="display-important-info" :class="colorClass">
            {{ item.account }}
          </span>
        </div>

        <div class="md-layout-item md-size-40">
          <span>{{ $t("applications.Name") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span
            ><strong>{{ item.accountName }}</strong></span
          >
        </div>

        <div class="md-layout-item md-size-40">
          <span>{{ $t("captureMR.ColumnMeterNo") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span class="display-important-info" :class="colorClass">
            {{ item.meterRef }}
          </span>
        </div>

        <div class="md-layout-item md-size-40">
          <span>{{ $t("enquiries.plotNo") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span
            ><strong>{{ item.plotNo }}</strong></span
          >
        </div>

        <div class="md-layout-item md-size-40">
          <span>{{ $t("activities.cellPhone") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span
            ><strong>{{ item.cellTelNo }}</strong></span
          >
        </div>

        <div class="md-layout-item md-size-40">
          <span>{{ $t("captureMR.propertyAddress") }}</span>
        </div>
        <div class="md-layout-item md-size-60">
          <span>{{ item.address }}</span>
        </div>
      </div>
    </div>
  </md-table-cell>
</template>

<script>
export default {
  name: "readingsListCell",
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItemId: {
      type: Number,
      default: -1,
    },
    colorClass: {
      type: String,
      default: null,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    isItemSelected(item) {
      return this.selectedItemId == item.sequence
        ? "background-color-gray_wached"
        : "";
    },
    isUnderInvestigation(item) {
      return item.status === 3 ? "is-under-investigation border-radius-4" : "";
    },
  },
};
</script>
<style>
.cell-formatting {
  width: 100% !important;
  padding: 5px !important;
  margin-left: 1px !important;
}

.display-important-info {
  font-weight: bold;
}

.is-under-investigation {
  border: 2px solid var(--orange);
}

.margin-left-6px {
  margin-left: 6px !important;
}

.fix-margin-padding .md-table-cell-container {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
